import gql from 'graphql-tag';

export const GET_COMANIES_FOR_MANAGER = gql`
  query getCompanies($pagination: PaginationInputType!, $marketId: Int, $regCode: String, $companyName: String, $isAutopilotClient: Boolean, $accountantId: UuidType, $withoutAccountant: Boolean) {
    accounting {
      getCompanies(pagination: $pagination, marketId: $marketId, regCode: $regCode, companyName: $companyName, isAutopilotClient: $isAutopilotClient, accountantId: $accountantId, withoutAccountant: $withoutAccountant) {
        companyFolders {
          companyId
          name
          displayName
          isAutopilotClient
          assignedAccountants {
            id
            email
            name
            surname
          }
        }
        limit
        offset
        total
      }
    }
  }
`;

export const GET_COMPANY_LIST_ACCOUNTANTS = gql`
  query getCompanyListAccountants {
    accounting {
      companyListAccountants {
        id
        email
        name
        surname
      }
    }
  }
`;

export const GET_COMPANIES_COUNTS = gql`
  query getCompaniesCounts($pagination: PaginationInputType!, $marketId: Int, $regCode: String, $companyName: String, $isAutopilotClient: Boolean, $accountantId: UuidType, $withoutAccountant: Boolean) {
    accounting {
      getCompanies(pagination: $pagination, marketId: $marketId, regCode: $regCode, companyName: $companyName, isAutopilotClient: $isAutopilotClient, accountantId: $accountantId, withoutAccountant: $withoutAccountant) {
        companyFolders {
          companyId
          unreadMessagesCount
        }
      }
    }
  }
`;

export const GET_COMPANY_WITH_FOLDERS = gql`
  query getCompanyWithFolders($idCompany: String) {
    accounting {
      getCompanyWithFolders(id_company: $idCompany) {
        company {
          id
          name
          marketId
          isAutopilotClient
        }
        companyFolder {
          id
          name
          createdAt
        }
        folders {
          id
          name
          createdAt
          unreadFilesQty
          totalFilesQty
          periods {
            id
            name
            year
            month
            quarter
            createdAt
          }
        }
      }
    }
  }
`;

export const GET_COMPANY_FOLDERS_UNREAD_COUNTS = gql`
  query getCompanyFoldersUnreadCounts($idCompany: String) {
    accounting {
      getCompanyWithFolders(id_company: $idCompany) {
        folders {
          id
          periods {
             id
             unreadMessagesCount
          }
        }
      }
    }
  }
`;

export const GET_COMPANY_YEAR_FOLDER_WITH_PERIODS = gql`
  query getCompanyYearFolderWithPeriods($idYearFolder: String) {
    accounting {
      getCompanyYearFolderWithPeriods(id_year_folder: $idYearFolder) {
        yearFolder {
          name
          id
          createdAt
          companyFolder {
            id
            companyId
            name
            company {
              name
            }
          }
        }
        periods {
          id
          quarter
          month
          year
          periodType
          year
          statusApproved
          name
          unreadFilesQty
          totalFilesQty
          reason
        }
      }
    }
  }
`;

export const GET_PERIODS_UNREAD_COUNTS = gql`
  query getPeriodsUnreadCounts($idYearFolder: String) {
    accounting {
      getCompanyYearFolderWithPeriods(id_year_folder: $idYearFolder) {
        periods {
          id
          unreadMessagesCount
        }
      }
    }
  }
`;

export const GET_PERIOD_WITH_SUBFOLDERS = gql`
  query getPeriodWithSubfolders($idPeriodFolder: String) {
    accounting {
      getPeriodWithSubfolders(id_period_folder: $idPeriodFolder) {
        subfolders {
          name
          id
          periodsFolderId
          type
          createdAt
          totalFilesQty
        }
        period {
          id
          name
          periodType
          reason
          company {
            id
            name
            marketId
          }
          yearFolderId
          yearFolder {
            name
            id
            companyFolder {
              name
              id
            }
          }
        }
      }
    }
  }
`;

export const GET_SUBFOLDERS_COUNTS = gql`
  query getSubfoldersCounts($idPeriodFolder: String) {
    accounting {
      getPeriodWithSubfolders(id_period_folder: $idPeriodFolder) {
        subfolders {
          id
          unreadFilesQty
        }
      }
    }
  }
`;

export const GET_PERIOD = gql`
  query getPeriod($idPeriodFolder: String) {
    accounting {
      getPeriodWithSubfolders(id_period_folder: $idPeriodFolder) {
        period {
          id
          name
          yearFolderId
          chaserTaskId
          yearFolder {
            name
            id
            companyFolder {
              name
              id
            }
          }
        }
      }
    }
  }
`;

export const GET_COMPANY_PERIOD_SUBFOLDER = gql`
  query getCompanyPeriodSubFolder($periodSubfolderId: String, $sortFields: [GetCompanyPeriodSubFolderSortFieldDtoInputType!], $search: String) {
    accounting {
      getCompanyPeriodSubFolder(period_subfolder_id: $periodSubfolderId, sortFields: $sortFields, search: $search) {
        subFolder {
          id
          name
          periodsFolderId
          type
          createdAt
          periodsFolder {
            id
            name
            companyId
            yearFolderId
            accountingType
            quarter
            month
            year
            periodType
            createdAt
            statusApproved
            vatLink
            vatSum
            tsdLink
            tsdSum
            company {
              name
              marketId
              email
            }
            yearFolder {
              name
              id
              companyFolder {
                name
                id
              }
            }
          }
        }
        files {
          id
          name
          createdAt
          isRead
          accStatusId
          rejectionComment
          rejectionReasonId
          meritInvoiceId
          meritRefNo
          meritShipmentStatus
          meritShipmentError
          customerVatNumber
          source
          moniteInvoice {
            documentType
          }
        }
      }
    }
  }
`;

export const GET_COMPANY_CONTRACTS_FOLDERS = gql`
  query getCompanyContractsFolders($idCompany: String) {
    accounting {
      getCompanyContractsFolders(id_company: $idCompany) {
        contractsFolders {
          id
          name
          createdAt
        }
        company {
          id
          name
        }
        companyFolder {
          id
          name
        }
      }
    }
  }
`;

export const GET_CONTRACTS_FOLDER_WITH_FILES = gql`
  query GetContractsFolderWithFiles($idContractsFolder: String) {
    accounting {
      getContractsFolderWithFiles(id_contracts_folder: $idContractsFolder) {
        contractsFolder {
          id
          name
          companyFolder {
            id
            name
            company {
              name
              id
            }
          }
        }
        contractsFiles {
          name
          id
          createdAt
        }
      }
    }
  }
`;
